export default __webpack_public_path__ + "images/1a0b55ef7230bea3ba19ea841d8e16a9.jpg";